export default __webpack_public_path__ + "assets/emily.0bb17e2c.png";